import { useEffect } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import Gallery from "@/components/site/Gallery";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  useEffect(() => {
    document.title = "Face It Aesthetics — Cosmetic RN, Belmore NSW";

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.14 }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <main data-testid="home-page" className="bg-[#FAFAF8] text-[#2C2723]">
      <Header />
      <Hero />
      <About />
      <Services />
      <WhyUs />
      <Gallery />
      <Contact />
      <Footer />
    </main>
  );
}
